<template>
    <v-container>
        <v-row>
          <v-flex>
            <v-card elevation="12" class="border" style="width: calc(100svw - 2svw - 2svw); height: 13.4svh; margin-top: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: flex-start;">
              <img src="./../assets/images/calper_light.svg" style="margin-top: auto; margin-bottom: auto; margin-left: 5.3svw; width: 137px;"/>
            </v-card>
          </v-flex>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'CardNav',
}
</script>

<style>
.border {
  box-sizing: border-box;
  border: 1px solid #E9F6FB;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
  background: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/CardNav.vue